export const labelColor = (label: string) => {
  if (label === "amarillo") {
    return "Oro A";
  }
  if (label === "rojo") {
    return "Oro R";
  }
  if (label === "blanco") {
    return "Oro B";
  }
  if (label === "plata") {
    return "Plata";
  }
  if (label === "rose") {
    return "Rosé";
  }
  if (label === "golden") {
    return "Dorado";
  }
  if (label === "soaked") {
    return "Empavonado";
  } else return "Seleccionar";
};

export const addedVariantsLabelColor = (label: string) => {
  if (label === "amarillo") {
    return "amarillo";
  }
  if (label === "rojo") {
    return "rojo";
  }
  if (label === "blanco") {
    return "blanco";
  }
  if (label === "plata") {
    return "Plata";
  }
  if (label === "rose") {
    return "Rosé";
  }
  if (label === "golden") {
    return "Dorado";
  }
  if (label === "soaked") {
    return "Empavonado";
  }
  if (label === "plata") {
  return "Plata"
  }
  return "";
};
